module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House67.a05d3123.jpg";